module.exports = __webpack_public_path__ + "static/media/wheeled-BG-3rd-layer-three@2x.05f54de0.png";